import { useEffect, useState } from "react";
import { useAuth } from "../AuthContext";
import { adminApi, errMsg } from "../api";
import { Field, TextInput } from "../components";
import { toast } from "../../components/ui/sonner";

export default function UsersAdmin() {
  const { user, refreshUser } = useAuth();
  const [users, setUsers] = useState([]);
  const [cred, setCred] = useState({ current_password: "", new_password: "", new_email: "" });
  const [nu, setNu] = useState({ email: "", password: "", name: "", role: "editor" });
  const [busy, setBusy] = useState(false);

  const isAdmin = user?.role === "admin";
  const load = () => { if (isAdmin) adminApi.get("/auth/users").then((r) => setUsers(r.data)).catch(() => {}); };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [isAdmin]);

  const changeCreds = async () => {
    if (!cred.current_password) return toast.error("Enter your current password");
    setBusy(true);
    try {
      const payload = { current_password: cred.current_password };
      if (cred.new_password) payload.new_password = cred.new_password;
      if (cred.new_email) payload.new_email = cred.new_email;
      await adminApi.post("/auth/change-credentials", payload);
      toast.success("Credentials updated");
      setCred({ current_password: "", new_password: "", new_email: "" });
      refreshUser();
    } catch (e) { toast.error(errMsg(e)); }
    finally { setBusy(false); }
  };

  const createUser = async () => {
    setBusy(true);
    try {
      await adminApi.post("/auth/users", nu);
      toast.success("User created");
      setNu({ email: "", password: "", name: "", role: "editor" });
      load();
    } catch (e) { toast.error(errMsg(e)); }
    finally { setBusy(false); }
  };

  const toggleUser = async (u) => {
    try {
      await adminApi.patch(`/auth/users/${u.id}`, { active: !u.active });
      toast.success(u.active ? "Deactivated" : "Reactivated");
      load();
    } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div data-testid="admin-users-page">
      <div className="adm-head">
        <div><h1>Users & Account</h1><div className="sub">Signed in as {user?.email} ({user?.role})</div></div>
      </div>

      <div className="adm-card">
        <h2>My account</h2>
        <div className="adm-grid cols-3">
          <Field label="Current password" hint="required">
            <TextInput type="password" value={cred.current_password} onChange={(v) => setCred({ ...cred, current_password: v })} data-testid="cred-current" />
          </Field>
          <Field label="New password" hint="min 8 chars, optional">
            <TextInput type="password" value={cred.new_password} onChange={(v) => setCred({ ...cred, new_password: v })} data-testid="cred-new-password" />
          </Field>
          <Field label="New email" hint="optional">
            <TextInput type="email" value={cred.new_email} onChange={(v) => setCred({ ...cred, new_email: v })} data-testid="cred-new-email" />
          </Field>
        </div>
        <button className="adm-btn primary" onClick={changeCreds} disabled={busy} data-testid="save-credentials">Update credentials</button>
      </div>

      {isAdmin && (
        <>
          <div className="adm-card">
            <h2>Add user</h2>
            <div className="adm-grid cols-4">
              <Field label="Email"><TextInput type="email" value={nu.email} onChange={(v) => setNu({ ...nu, email: v })} data-testid="new-user-email" /></Field>
              <Field label="Password" hint="min 8"><TextInput type="password" value={nu.password} onChange={(v) => setNu({ ...nu, password: v })} data-testid="new-user-password" /></Field>
              <Field label="Name"><TextInput value={nu.name} onChange={(v) => setNu({ ...nu, name: v })} /></Field>
              <Field label="Role">
                <select value={nu.role} onChange={(e) => setNu({ ...nu, role: e.target.value })} data-testid="new-user-role">
                  <option value="editor">editor</option>
                  <option value="admin">admin</option>
                </select>
              </Field>
            </div>
            <button className="adm-btn primary" onClick={createUser} disabled={busy || !nu.email || nu.password.length < 8} data-testid="create-user">Create user</button>
          </div>

          <div className="adm-card" style={{ padding: 0 }}>
            <table className="adm-table">
              <thead><tr><th>Email</th><th>Name</th><th>Role</th><th>Status</th><th style={{ width: 120 }}></th></tr></thead>
              <tbody>
                {users.map((u) => (
                  <tr key={u.id}>
                    <td>{u.email}</td>
                    <td>{u.name}</td>
                    <td className="mono">{u.role}</td>
                    <td><span className={`adm-badge ${u.active ? "on" : "off"}`}>{u.active ? "active" : "deactivated"}</span></td>
                    <td>
                      {u.id !== user?.id && (
                        <button className={`adm-btn ${u.active ? "danger" : "ghost"} sm`} onClick={() => toggleUser(u)} data-testid={`toggle-${u.email}`}>
                          {u.active ? "Deactivate" : "Reactivate"}
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
